import { useMemo } from 'react';

import { getFilterOptions } from '../../helpers/filter';

export const useFilterOptions = data => {
  return useMemo(() => {
    if (!Array.isArray(data) || data.length === 0) {
      return {
        breeds: [],
        majorMeasurementNames: [],
        minorMeasurementNames: [],
        sex: []
      };
    }

    return {
      breeds: getFilterOptions(data, 'breed'),
      majorMeasurementNames: getFilterOptions(data, 'major_measurement_name'),
      minorMeasurementNames: getFilterOptions(data, 'minor_measurement_name'),
      sex: getFilterOptions(data, 'sex')
    };
  }, [data]);
};
